import { render, staticRenderFns } from "./personnav.html?vue&type=template&id=06c9d69b&scoped=true&"
import script from "./personnav.js?vue&type=script&lang=js&"
export * from "./personnav.js?vue&type=script&lang=js&"
import style0 from "./personnav.sass?vue&type=style&index=0&id=06c9d69b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c9d69b",
  null
  
)

component.options.__file = "personnav.vue"
export default component.exports